<template>
    <div class="user">
<!--        <el-card>-->
<!--            <el-page-header v-if="from == 'user'" @back="goBack" :content="'用户管理('+ name + ')'"></el-page-header>-->
<!--            <el-breadcrumb v-if="from == 'menu'" separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>人力资源</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>员工管理</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <div style="text-align: right;padding-bottom: 10px" >
                    <el-button type="primary" @click="handleCreateUser" size="mini">添加员工</el-button>
                    <el-button type="primary" size="mini" @click="exportUser()">导出</el-button>
                </div>
                <el-table
                    stripe
                    :data="tableData"
                    v-loading="loading"
                    @selection-change="handleSelectionChange"
                    style="width: 100%">
                    <el-table-column type="selection" width="55"/>
                    <el-table-column
                        prop="name"
                        label="姓名"
                        width="120"/>
                    <el-table-column width="170"
                            prop="email"
                            label="邮箱"/>
                    <el-table-column
                            prop="companyName"
                            label="公司">

                    </el-table-column>
                    <el-table-column
                            prop="dname"
                            label="部门"/>
                    <el-table-column
                        prop="mobile"
                        label="手机号"
                        width="180">
                    </el-table-column>
                    <el-table-column
                            prop="type"
                            label="账号类型"
                            width="100">
                        <template slot-scope="scope">
                            {{scope.row.type ===  1 ? '管理/审核' : "需求人"}}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="200" align="right">

                        <template slot-scope="scope">
                            <el-button type="text"
                                size="mini"
                                @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                            <el-divider direction="vertical" ></el-divider>
                            <el-button type="text"
                                size="mini"
                                @click="handleResetPassword(scope.$index, scope.row)">重置密码</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                        background
                        layout="sizes,prev, pager, next"
                        :total="total"
                        :page-sizes="[10, 20, 50, 100]"
                        v-if="total>0"
                        :page-size="pageSize"
                        @size-change="handleSizeChange"
                        @current-change="onPageChange"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>

        <el-dialog title="用户信息" :visible.sync="editDialogVisible" :before-close="handleClose" width="500px">
            <el-form :model="editForm" label-width="80px" :rules="rules" ref="userInfoForm">
                <el-form-item label="类型" prop="kind" size="mini">
                    <el-select v-model="editForm.kind" :disabled="isEdit" placeholder="请选择账号类型">
                        <el-option label="需求人" value="0"></el-option>
                        <el-option label="管理/审核" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="邮箱" prop="email" size="mini">
                    <el-input v-model="editForm.email" :disabled="isEdit" placeholder="请输入邮箱" clearable></el-input>
                </el-form-item>
                <el-form-item label="密码" v-if="editForm.id === ''" prop="password" size="mini">
                    <el-input v-model="editForm.password" show-password placeholder="请输入密码" clearable></el-input>
                </el-form-item>
                <el-form-item label="姓名" prop="name" size="mini">
                    <el-input v-model="editForm.name" placeholder="请输入姓名" clearable></el-input>
                </el-form-item>
                <el-form-item label="手机" prop="mobile" size="mini">
                    <el-input v-model="editForm.mobile" placeholder="请输入手机" clearable></el-input>
                </el-form-item>
                <!-- <el-form-item label="状态">
                    <el-select v-model="editForm.status" placeholder="请选择账号状态">
                        <el-option label="无效" value="0"></el-option>
                        <el-option label="有效" value="1"></el-option>
                    </el-select>
                </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false" size="mini">取 消</el-button>
                <el-button type="primary" @click="onSubmit" size="mini">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="重置密码" :visible.sync="mdyPasswordDialogVisible" width="500px">
            <el-form class="user-account-key" ref="editForm" :model="editForm" :rules="rules" label-width="100px">
                <el-form-item label="新密码" prop="password" size="mini">
                    <el-input type="password" placeholder="请设置新密码" show-password v-model="editForm.password" clearable></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="rPassword" size="mini">
                    <el-input type="password" placeholder="请确认新密码" show-password v-model="editForm.rPassword" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="mdyPasswordDialogVisible=false" size="mini">取消</el-button>
                <el-button type="primary" @click="onSubmitPwd('editForm')" size="mini">保存</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
    import {convertRes2Blob, downloadByPost} from "../../utils/download";

    export default {

    data() {
        //此处即表单发送之前验证
        let validateNewPassword2 = (rule, value, callback) => {
            if (value !== "" && value !== this.editForm.password) {
                callback(new Error('两次密码不一致!'))
            } else {
                callback()
            }
        }
        return {
            selectData:[],
            searchForm: {
                name: "",
                email: "",
                mobile: "",
                password: "",
                // type: "",
                // vip: "",
                companyTaxCode: "",
                businessLicense: "",
                status: "",
            },
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],
            editDialogVisible: false,
            editForm: {
                id: "",
                name: "",
                email: "",
                mobile: "",
                password: "",
                iPassword: "",
                rPassword: "",
                companyId: "",
                type: "1",
                kind: "",

            },
            isEdit: true,
            mdyPasswordDialogVisible: false,
            editRoleVisible: false,
            userId: "",
            uploadDialogVisible: false,
            uploadCheckResult: "",
            rules: {
                kind: [
                    { required: true, message: '请选择账号类型', trigger: 'blur' }
                ],
                email: [
                    { required: true, message: '请输入邮箱', trigger: 'blur' }
                ],
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                mobile: [
                    { required: true, message: '请输入手机号', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请设置新密码', trigger: 'blur' }
                ],
                rPassword: [
                    { required: true, message: '请确认新密码', trigger: 'blur' },
                    { validator: validateNewPassword2, trigger: 'blur' }
                ]
            }
        }
    },
    props: ["from", "companyId","name"],
    methods: {
        onSearch() {
            this.loading = true;
            let _this = this
            this.$axios.post("/admin/company/companyUsers",this.companyId).then(function(response) {
                let resp = response.data;
                if(resp.header.status == 0) {
                    _this.loading = false;
                    _this.tableData = resp.data;
                }
            }).catch(function() {
            });
        },
        handleCreateUser() {
            this.isEdit = false;
            this.editForm.id = "";
            this.editForm.name = "";
            this.editForm.email = "";
            this.editForm.mobile = "";
            this.editForm.password = "";
            // this.editForm.vip = "0";
            // this.editForm.type = "0";
            this.editForm.status = "1";
            this.editForm.kind = "";
            this.editForm.companyId = this.companyId;
            this.editDialogVisible = true;
            this.$refs.userInfoForm.clearValidate();
        },
        // handleEdit(_index, row) {
        //     this.isEdit = true;
        //     this.editForm.id = row.id;
        //     this.editForm.name = row.name;
        //     this.editForm.email = row.email;
        //     this.editForm.mobile = row.mobile;
        //     // this.editForm.vip = row.vip+ "";
        //     // this.editForm.type = row.type+ "";
        //     this.editForm.status = row.status + "";
        //     this.editDialogVisible = true;
        // },
        onSubmit() {
            let _this = this;
            this.$refs.userInfoForm.validate(valid => {
                if (valid) {
                    if(this.editForm.kind === "0") {
                        this.$axios.post("/admin/user/save", this.editForm)
                        .then(function(response){
                            let resp = response.data;
                            if(resp.header.status == 0) {
                                _this.$notify({
                                    title: '成功',
                                    message: '数据保存成功',
                                    type: 'success'
                                });
                                _this.editDialogVisible = false;
                                _this.onSearch();
                            } else {
                                _this.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                    } else if(this.editForm.kind === '1') {
                        this.editForm.iPassword = this.editForm.password;
                        this.$axios.post("/admin/rights/staff", this.editForm)
                        .then(function(response){
                            let resp = response.data;
                            if(resp.header.status == 0) {
                                _this.$notify({
                                    title: '成功',
                                    message: '数据保存成功',
                                    type: 'success'
                                });
                                _this.editDialogVisible = false;
                                _this.onSearch();
                            } else {
                                _this.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                    }
                }
            });
        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        handleEdit(_index, row) {
            this.isEdit = true;
            this.editForm.id = row.id;
            this.editForm.name = row.name;
            this.editForm.email = row.email;
            this.editForm.mobile = row.mobile;
            // this.editForm.vip = row.vip+ "";
            // this.editForm.type = row.type+ "";
            this.editForm.status = row.status + "";
            this.editForm.kind = row.type + "";
            this.editDialogVisible = true;
        },
        handleResetPassword(index, row) {

            this.editForm.id = row.id;
            this.editForm.password = "";
            this.editForm.rPassword = "";
            this.editForm.type = row.type;
            this.mdyPasswordDialogVisible = true;
        },
        onSubmitPwd() {
            let _this = this;
            this.$refs.editForm.validate(valid => {
                if (valid) {
                    let data = {id:this.editForm.id,password:this.editForm.password,rPassword:this.editForm.rPassword};
                    let url = "/admin/user/modify/password";
                    if(this.editForm.type == 1){//后台用户
                        url = "/admin/rights/staff/resetPassword";
                        data = {id:this.editForm.id,iPassword:this.editForm.password,rPassword:this.editForm.rPassword};
                    }
                    this.$axios.post(url, data)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status == 0) {
                                _this.$notify({
                                    title: '成功',
                                    message: '数据保存成功',
                                    type: 'success'
                                });
                                _this.mdyPasswordDialogVisible = false;
                                _this.onSearch();
                            } else {
                                _this.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                }
            })
        },
        handleClose() {},
        uploadSuccess(response) {
            const {header: {status, msg}} = response;
            this.$refs.upload.clearFiles();
            if(status === 0) {
                this.$notify({
                    title: '成功',
                    message: '数据保存成功',
                    type: 'success'
                });
                this.uploadDialogVisible = false;
                this.onSearch();
            } else {
                this.uploadCheckResult = msg;
            }
        },
        goBack() {
            this.$router.go(-1);
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        exportUser(){
            if(this.selectData.length == 0){
                this.$message({
                    type: 'info',
                    message: '请选择要导出的用户',
                    duration: 2000
                });
                return;
            }
            const that = this;
            let arr = [];
            let val = this.selectData;
            if(val.length>0){
                for(let i=0; i<val.length; i++){
                    arr.push(val[i].id);
                }
                downloadByPost({
                    axios: that.$axios,
                    url: "/admin/easypoi/users",
                    data: {ids:arr,companyId:that.companyId},
                    success: response => {
                        convertRes2Blob(response);
                    },
                });
            }
        },
    },
    created() {
        this.onSearch()
    },
}
</script>
<style>
</style>
